export type BranchFeeCategory = {
  id: number;
  category: string;
  account_detail_id?: number;
};

export type BranchFeeCategoriesData = {
  fee_categories: BranchFeeCategory[];
  is_fee_configured: boolean;
};

type BranchFeeCategoriesPayload =
  | BranchFeeCategory[]
  | {
      fee_categories?: BranchFeeCategory[];
      is_fee_configured?: boolean;
      data?: BranchFeeCategory[];
    };

/** Normalize GET .../fee-categories body into fee list + configured flag. */
export const normalizeBranchFeeCategoriesResponse = (
  payload: BranchFeeCategoriesPayload | null | undefined
): BranchFeeCategoriesData => {
  if (!payload) {
    return { fee_categories: [], is_fee_configured: false };
  }

  if (Array.isArray(payload)) {
    return {
      fee_categories: payload,
      is_fee_configured: payload.length > 0
    };
  }

  const feeCategories = payload.fee_categories ?? payload.data ?? [];
  return {
    fee_categories: feeCategories,
    is_fee_configured:
      typeof payload.is_fee_configured === 'boolean'
        ? payload.is_fee_configured
        : feeCategories.length > 0
  };
};

export const mergeBranchWithFeeCategories = <T extends object>(
  branch: T,
  feeData?: BranchFeeCategoriesData | null
): T & BranchFeeCategoriesData => ({
  ...branch,
  fee_categories: feeData?.fee_categories ?? [],
  is_fee_configured: feeData?.is_fee_configured ?? false
});
